import styled from 'styled-components';

export const StyledBasicUpload = styled.div`
  .bu-wrapper {
    width: 343px;
    height: 192px;
    border: 2px dotted #ffd5d7;
    box-shadow: 0px 0px 6px 0px #00000026;

    &.btn {
      width: fit-content;
      height: auto;
      border: none;
      box-shadow: none;

      .ant-upload-wrapper {
        .ant-upload-select {
          border: none;
        }
      }
    }

    .ant-upload-wrapper {
      height: 100%;

      .ant-upload-select {
        width: 100%;
        height: 100%;
        margin-inline-end: 0;
        margin-bottom: 0;
        background-color: transparent;
        border-radius: 0;

        & .ant-upload {
          width: 100%;
          height: 100%;
          .bu-wapper-box {
            &-top {
              &-img {
                width: 52px;
                height: 52px;

                > img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
`;
